import { PermissionValues as Permissions } from '@gripp/shared-logic';
import { EditRoutine } from './components/editRoutine';
import { NewRoutine } from './components/newRoutine';
import { Routines } from './components/routines';
import { RoutinesToolbar } from './components/routinesToolbar';
import { routinesPaths } from './routinesPaths';

const newRoutineHeader = {
  titleKey: 'routines.new.header',
  icon: 'format-list-checks',
};

const editRoutineHeader = {
  titleKey: 'routines.edit.header',
  icon: 'format-list-checks',
};

export const newRoutinesRoutes = [
  {
    path: `${routinesPaths.root}/*`,
    element: <Routines />,
    handle: {
      header: {
        titleKey: 'assets.list.routines',
        icon: 'format-list-checks',
      },
      requiredPermission: Permissions.routinespage.read,
      toolbar: <RoutinesToolbar />,
    },
    children: [],
  },
  {
    path: `${routinesPaths.new}/:type`,
    element: <NewRoutine />,
    handle: {
      header: newRoutineHeader,
      requiredPermission: Permissions.routinespage.read,
    },
  },
  {
    path: `${routinesPaths.edit}`,
    element: <EditRoutine />,
    handle: {
      header: editRoutineHeader,
      requiredPermission: Permissions.routinespage.read,
    },
  },
];
